import { generateUniqueId, stripTimestampAndExtension } from '@/assets/js/Utilities';

export default class AIColourExtract {
	constructor() {
		this.blockName = 'ai-colour-extract';
		this.version = "1";
		this.img_size = 128;
		this.lut_size = 26;
		this.model = null;

		this.curveNames = ["WhiteBalance-R", "WhiteBalance-G", "WhiteBalance-B", "Tint-R", "Tint-G", "Tint-B"];

		this.whiteBalance = {
			minValue: -4000,
			maxValue: 4000,
			calcValue: 8000,
		};

		this.tint = {
			minValue: -100,
			maxValue: 100,
			calcValue: 100,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};

		this.colourMatchValues = {
			ColorSpace: 1,
			CrossCovarianceLimit: 0,
			ReshapingIterations: 0,
			PercentSaturationShift: 85,
			PercentShadingShift: 45,
			ExtraShading: false,
			ScaleRatherThanClip: false,
			PercentTint: 80,
			PercentModified: 75,
		}
	}

	async addBlock(blockNum = lutify.blocks.length, selectedSampleFile = false) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		UI.removeBlockBlendingModes($(element));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);

		await this.loadModel();

		$(element)
			.find(".white_balance_slider")
			.on("input", () => _Adjustments.whiteBalance.whiteBalanceHandler($(element)));
		$(element)
			.find(".white_balance_range")
			.on("change", () => _Adjustments.whiteBalance.whiteBalanceValueHandler($(element)));

		$(element)
			.find(".tint_slider")
			.on("input", _ => _Adjustments.whiteBalance.tintHandler($(element)));
		$(element)
			.find(".tint_range")
			.on("change", _ => _Adjustments.whiteBalance.tintValueHandler($(element)));

		$(element)
			.find(".lut-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				if ($(e.currentTarget).hasClass('disabled')) return;
				this.togglePresetSelector($(e.currentTarget));
			});

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		$(element)
			.find(".btn-reset-block")
			.on("click", e => {
				e.stopPropagation();
				this.resetBlock($(element));
			});

		$(element).on("click", e => {
			e.stopImmediatePropagation();
			// UI.hideLUTtemplates();
			if (!lutify.getActiveBlock().sampleFile) return;
			if (!luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`]) return;
			if (luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].length == 0) return;
			this.showPreviews();
		});

		$(element).find('.sample-selector').on('click', e => {
			vm.$root.projectTree.openAIColourExtractModal(vm.$store.state.Projects.currentFile, 'updateAIColourExtractSample');
		});

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "AIColourExtract",
			passes: this.addPasses(),
			curves: [],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			presetId: null,
			sampleFile: null,
			opacity: 100,

			values: {
				whiteBalance: 0,
				tint: 0,
			}
		});

		$(element).find(".lut-selector__items-container").hide();

		blocks.createCurves(this.curveNames, blockNum);

		if (!vm.$store.state.UI.showAddMatchTooltip && vm.$store.getters['Projects/allMatches'].length == 0) {
			vm.$store.dispatch('UI/setAddMatchTooltip', "Please load a reference image first, then save it as a Match using the option above to start using the AI Colour Extract tool");
		}
	}

	async loadModel() {
		if (this.model) return;
		if (vm.$store.state.UI.AIColourExtract.isDownloading) {
			this.showDownloadProgress();
			return;
		}

		let storeData = await this.isModelDownloaded();

		if (storeData) {
			// console.log('[FETCH][INDEXEDDB] model and weights')
		} else {
			vm.$store.dispatch('UI/setAIColourExtractDownloading', true);

			let response = await vm.$store.dispatch('Projects/fetchSystemFiles', {
				block: this.blockName
			});

			// console.log('[FETCH][SERVER] model')
			let model = await fetch(response[0].presignedURL);
			// console.log('[FETCH][SERVER] weights')
			let weights = await fetch(response[1].presignedURL);
			let weightsClone = weights.clone();
			const total = Number(weights.headers.get('content-length'));

			this.showDownloadProgress();

			const reader = weights.body.getReader();
			let bytesReceived = 0;
			let loop = true;

			let interval = setInterval(async () => {
				if (bytesReceived >= total) {
					clearInterval(interval);
					vm.$snackbar('AI model downloaded. You may now use the AI Colour Extract tool.', 'success');
				}
				vm.$store.dispatch('UI/setAIColourExtractDownloadProgress', Math.round(bytesReceived * 100 / total));
			}, 500)

			while (loop) {
				const result = await reader.read();
				if (result.done) break;
				bytesReceived += result.value.length;
			}

			storeData = {
				model: await model.blob(),
				weights: await weightsClone.blob(),
			}

			vm.$store.dispatch('UI/setAIColourExtractDownloading', false);
			await window.blocksStore.setItem('AIColourExtract', storeData);
		}

		storeData.weights.name = 'group1-shard1of1.bin';

		this.model = await window.tf.loadGraphModel(window.tf.io.browserFiles(
			[storeData.model, storeData.weights]));
	}

	async loadLuts() {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		UI.appendBlockLoadingSpinner($(UI.getActiveBlock()));

		UI.togglePreviewsContainer();
		lutPreviewer.showPlaceholderPreviews()

		let data = {
			control: 'LUTcontrols',
			category: 'White Balance'
		}

		await _Adjustments.LUTcontrols.load(data);

		if (typeof luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`] == "undefined") luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`] = [];
		let lutObjectsList = []

		let lutObjectClone = { ...lutify.getActiveBlock().lutObjects[0] };
		lutObjectClone.category = `AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`;
		lutObjectClone.presetId = 0;
		lutObjectClone.title = 'The Magic Look';
		luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].push(lutObjectClone);
		lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourExtract');
		lutObjectsList.push(lutObjectClone);

		let lutObjectClone2 = { ...lutify.getActiveBlock().lutObjects[0] };
		lutObjectClone2.category = `AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`;
		lutObjectClone2.presetId = 1;
		lutObjectClone2.title = 'Gamut Only';
		luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].push(lutObjectClone2);
		lutPreviewer.createPreviews([lutObjectClone2], false, undefined, 'AIColourExtract');
		lutObjectsList.push(lutObjectClone2);

		for await (const [key, lutObject] of luts[data.control][data.category].entries()) {
			let lutObjectClone = { ...lutObject };
			lutObjectClone.category = `AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`;
			lutObjectClone.presetId = key + 2;
			let titleSplitted = lutObjectClone.title.split(/(\-|\+)/g);
			lutObjectClone.title = `The Magic Look ${titleSplitted[1]} WB ${titleSplitted[2]}`;

			luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].push(lutObjectClone);
			lutPreviewer.createPreviews([lutObjectClone], false, undefined, 'AIColourExtract');
			lutObjectsList.push(lutObjectClone);
		}

		this.setPresetList(lutObjectsList);

		vm.$store.dispatch("Loader/showProgressBar", false);
		UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));
		lutPreviewer.removePlaceholderPreviews();
		UI.getActiveBlock().click();
	}

	addPasses() {
		let shaderPass_wb = gpu.createCurveShaderPass("white balance");
		let shaderPass_tint = gpu.createCurveShaderPass("tint");
		let passWhiteBalanceLut = gpu.createRenderPass();
		let passAIColoutExtract = gpu.createRenderPass();
		let passColoutMatch = gpu.createRenderPass();

		gpu.addPassToComposer(shaderPass_wb, "toMiddle");
		gpu.addPassToComposer(shaderPass_tint, "toMiddle");
		gpu.addPassToComposer(passWhiteBalanceLut, "toMiddle");
		gpu.addPassToComposer(passAIColoutExtract, "toMiddle");
		gpu.addPassToComposer(passColoutMatch, "toMiddle");

		return [shaderPass_wb, shaderPass_tint, passWhiteBalanceLut, passAIColoutExtract, passColoutMatch];
	}

	togglePresetSelector($el) {
		let itemsContainer = $el.siblings(".lut-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	onPresetSelection(el, preset) {
		let category = 'AIColourExtract-' + lutify.getActiveBlock().passes[2].uid;
		$(`#previews-list-container .list-item[data-category="${category}"][data-preset-id="${preset.presetId}"]`).trigger('click');
		this.updatePresetList(preset);
	}

	updatePresetList(preset = false) {
		let $lutSelector = $(UI.getActiveBlock()).find(".lut-selector");
		$lutSelector.find(".lut-selector__items-container").hide();
		$lutSelector
			.find(`.lut-selector__items-container .--selected`)
			.removeClass("--selected");

		if (lutify.getActiveBlock().presetId !== null && preset) {
			$lutSelector.find(".selected-lut-name").html('Look: ' + preset.title);
			$lutSelector
				.find(`.lut-selector__items-container span[data-preset-id="${preset.presetId}"]`).addClass("--selected");
		} else {
			$lutSelector.find(".selected-lut-name").html('Select Look...');
		}
	}

	setPresetList(presets) {
		let $block = UI.getActiveBlock();

		presets.forEach(preset => {
			let el = document.createElement('span');
			el.innerHTML = preset.title;
			el.setAttribute('data-preset-id', preset.presetId);
			el.addEventListener('click', e => {
				this.onPresetSelection(e.currentTarget, preset);
			});

			$block.find('.lut-selector__items-container').append(el)
		});
	}

	async setSampleFile(file, lastState = false) {
		let activeBlock = lutify.getActiveBlock();
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		activeBlock.passes[2].uid = generateUniqueId();

		blocks.checkSwitchHandler($(UI.getActiveBlock()));

		activeBlock.sampleFile = {
			id: file.id,
			type: file.type,
		};

		let asset = vm.$store.getters["Projects/assetById"](file.id, file.type);
		let storeData;

		if (asset.type == 'image') storeData = await lutify.fetchImage(asset);
		else storeData = await lutify.fetchMatch(asset);
		let imageURL = URL.createObjectURL(storeData.blob);

		let img = new Image();
		img.src = imageURL;
		await img.decode();

		let tensor = window.tf.browser.fromPixels(img)
		tensor = window.tf.image.resizeNearestNeighbor(tensor, [this.img_size, this.img_size]);
		tensor = window.tf.div(tensor, 255);
		tensor = window.tf.reshape(tensor, [1, this.img_size, this.img_size, 3]);
		URL.revokeObjectURL(imageURL);

		let tensorLut = window.tf.tensor([]);
		tensorLut = this.model.predict(tensor);
		tensorLut = window.tf.reshape(tensorLut, [3, this.lut_size, this.lut_size, this.lut_size]);

		let LUT = this.tensorToLut(tensorLut)
		let loadedLUTs = await luts.load([LUT]);

		let pass = gpu.createLUTPass(loadedLUTs[0].texture);
		pass.name = "AI Colour Extract";
		let targetPass = activeBlock.passes[3];
		// pass.uid = targetPass.uid;
		let passIndex = gpu.getPassIndexById(targetPass.uid);
		activeBlock.passes[3] = pass;
		gpu.composer.passes[passIndex] = pass;

		// COLOUR MATCH
		await _Adjustments.colourMatch.initWorker();
		let sampleImage;
		if (asset.type == 'image') sampleImage = storeData.blob
		else sampleImage = storeData.imageIDTLMT

		let compressedImage = await readAndCompressImage(
			sampleImage,
			{
				quality: _Adjustments.colourMatch.quality,
				maxWidth: _Adjustments.colourMatch.maxWidth,
				maxHeight: _Adjustments.colourMatch.maxHeight,
			}
		);

		let compressedImageURL = URL.createObjectURL(compressedImage)
		let samplePixels = await _Adjustments.colourMatch.getPixels(compressedImageURL);
		URL.revokeObjectURL(compressedImageURL);

		let passes = blocks.getAllPassesToPass(activeBlock.passes[4].uid);
		let targetImage = lutify.getIDTLMTimage(passes);

		compressedImage = await readAndCompressImage(
			loader.dataURLtoFile(targetImage, `target.jpg`),
			{
				quality: _Adjustments.colourMatch.quality,
				maxWidth: _Adjustments.colourMatch.maxWidth,
				maxHeight: _Adjustments.colourMatch.maxHeight,
			}
		);

		compressedImageURL = URL.createObjectURL(compressedImage)
		let targetPixels = await _Adjustments.colourMatch.getPixels(compressedImageURL);
		URL.revokeObjectURL(compressedImageURL);

		LUT = await _Adjustments.colourMatch.getLut(
			this.colourMatchValues,
			targetPixels,
			samplePixels
		);
		let loadedColourMatchLUTs = await luts.load([LUT]);
		let colourMatchPass = gpu.createLUTPass(loadedColourMatchLUTs[0].texture);
		colourMatchPass.uid = activeBlock.passes[4].uid;
		colourMatchPass.name = 'Colour Match';
		let index = gpu.getPassIndexById(activeBlock.passes[4].uid);
		gpu.composer.passes[index] = colourMatchPass;
		activeBlock.passes[4] = colourMatchPass;

		gpu.render();

		activeBlock.lutObjects = [...loadedLUTs, ...loadedColourMatchLUTs];

		await this.loadLuts();

		if (!lastState) $(`#previews-list-container [data-category="AIColourExtract-${activeBlock.passes[2].uid}"][data-preset-id="0"] .scene`).trigger('click');

		this.resetOpacity();
		$(UI.getActiveBlock()).find('.lut-selector__label-container').removeClass('disabled');
		this.setSampleFileUI(storeData.blob, asset.name);
		vm.$store.dispatch("Loader/showProgressBar", false);
	}

	setSampleFileUI(imageBlob, name) {
		if (!lutify.getActiveBlock()) return;
		let block = UI.getActiveBlock();
		let $block = $(block);

		let imgSrc = URL.createObjectURL(imageBlob);
		let imgElement = document.createElement('img');
		imgElement.setAttribute('src', imgSrc);
		imgElement.setAttribute('class', 'thumbnail');
		imgElement.setAttribute('data-tippy-content', 'Click to change a Match');
		$block.find('.sample-selector img, .select-asset-btn').remove();
		$block.find('.sample-selector').prepend(imgElement);

		name = stripTimestampAndExtension(name);
		$block.find('.sample-selector .name').text(`Selected Match: ${name}`);
	}

	resetBlock($element) {
		this.resetOpacity();

		$element.find(".white_balance_range").val(0);
		$element.find(".white_balance_range").trigger('change');

		$element.find(".tint_range").val(0);
		$element.find(".tint_range").trigger('change');

		$(`#previews-list-container [data-category="AIColourExtract-${lutify.getActiveBlock().passes[2].uid}"][data-preset-id="0"] .scene`).trigger('click')

		lutPreviewer.render();
	}

	resetOpacity() {
		$(UI.getActiveBlock()).find(".opacity-input").val(100);
		$(UI.getActiveBlock()).find(".opacity-input").trigger("change");
	}

	showPreviews() {
		lutify.selectedPreviewCategory = `AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`;

		UI.togglePreviewsContainer();
		UI.updatePreviewsTab('AI Colour Extract');
		lutPreviewer.switchCanvases(`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`);
		// UI.updateSelectedPreview(lutify.getActiveBlock().selectedPreview);

		lutPreviewer.cloneMainComposerPasses();
		lutPreviewer.addPass('LUTcontrols', `AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`, 2, lutify.getActiveBlock().blendingMode, 'AIColourExtract');

		if (lutify.getActiveBlock().presetId) {
			let preset = luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].find(preset => preset.presetId == lutify.getActiveBlock().presetId)
			UI.updateSelectedPreview(preset.composerIndex);
		}

		this.showGarmutPreview();

		lutPreviewer.render();
		setTimeout(() => lutPreviewer.render(), 50); // because of visual glitch
	}

	showGarmutPreview() {
		// for garmut Preview
		let shaderPass = gpu.createLUTPass(lutify.getActiveBlock().lutObjects[1].texture);
		shaderPass.uid = lutify.getActiveBlock().passes[4].uid;
		shaderPass.uniforms.opacity.value = lutify.getActiveBlock().opacity * 0.01;
		shaderPass.enabled = true;

		let shaderPassGarmut = gpu.createLUTPass(lutify.getActiveBlock().lutObjects[1].texture);
		shaderPassGarmut.uid = lutify.getActiveBlock().passes[4].uid;
		shaderPassGarmut.uniforms.opacity.value = lutify.getActiveBlock().opacity * 0.01;
		shaderPassGarmut.enabled = false;

		luts['LUTcontrols'][`AIColourExtract-${lutify.getActiveBlock().passes[2].uid}`].forEach((preset, key) => {
			let passIndex = gpu.getPassIndexById(lutify.getActiveBlock().passes[4].uid);
			if (key == 1) {
				lutPreviewer.composers[preset.composerIndex].passes[passIndex] = shaderPassGarmut;
			} else {
				lutPreviewer.composers[preset.composerIndex].passes[passIndex] = shaderPass;
			}
		})
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes[2].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[3].uniforms.opacity.value = calcOpacityValue;
		lutify.getActiveBlock().passes[4].uniforms.opacity.value = calcOpacityValue;

		lutPreviewer.updateOpacity(calcOpacityValue, 2);
		lutPreviewer.updateOpacity(calcOpacityValue, 3);
		lutPreviewer.updateOpacity(calcOpacityValue, 4);
		// UI.setPreviewerOpacity(lutify.getActiveBlock().opacity);

		gpu.render();
		lutPreviewer.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	tensorToLut(tensorLut) {
		let bstr = '';
		bstr += 'TITLE AI Colour Extract\n';
		bstr += `LUT_3D_SIZE ${this.lut_size}\n`;
		bstr += '\n\n'

		let dataArray = tensorLut.arraySync();

		for (let r = 0; r < this.lut_size; r++) {
			for (let g = 0; g < this.lut_size; g++) {
				for (let b = 0; b < this.lut_size; b++) {
					bstr += dataArray[0][r][g][b].toFixed(6) + ' ' + dataArray[1][r][g][b].toFixed(6) + ' ' + dataArray[2][r][g][b].toFixed(6) + '\n';
				}
			}
		}

		let file = new File([bstr], 'ai-colour-extract.cube', { type: "text/plain" });

		return file;
	}

	showDownloadProgress() {
		vm.$snackbar(`Downloading AI model. This might take a while only the first time. `, "success", {
			timeout: -1,
			showAIColourExtractDownloadProgress: true,
		});
	}

	async isModelDownloaded() {
		let storeData = await window.blocksStore.getItem('AIColourExtract');
		return storeData;
	}

	async applyChanges($block, values, blockData) {
		let activeBlockData = lutify.getActiveBlock();
		vm.$store.dispatch('App/setBlockLoading', true);
		$('#blocks-container--outer').addClass('--overlay');
		$('#project-navigator-container').addClass('--overlay');
		$('#filmstrip-container .thumbnail-container').addClass('--overlay');

		try {
			_Adjustments.whiteBalance.applyChanges($block, values);
			activeBlockData.presetId = blockData.presetId;

			if (!blockData.sampleFile) return;

			if (!vm.$store.getters["Projects/assetById"](blockData.sampleFile.id, blockData.sampleFile.type)) {
				vm.$snackbar('Selected Match for AI Colour Extract is no longer available. Please select a new one or otherwise remove the AI Colour Extract tool.', 'error', {
					timeout: -1,
					contentClass: 'text-center'
				});
				return;
			}

			await this.setSampleFile(blockData.sampleFile, true);

			if (blockData.presetId) {
				let preset = luts['LUTcontrols'][`AIColourExtract-${activeBlockData.passes[2].uid}`].find(preset => preset.presetId == activeBlockData.presetId);
				let pass = gpu.createLUTPass(preset.texture);
				pass.name = "lut-" + blockData.presetId;
				pass.uid = activeBlockData.passes[2].uid;
				pass.uniforms.opacity.value = activeBlockData.opacity * 0.01;
				if (blockData.presetId <= 1) {
					pass.enabled = false;
				}

				activeBlockData.passes[2] = pass;
				let passIndex = gpu.getPassIndexById(pass.uid);
				gpu.composer.passes[passIndex] = activeBlockData.passes[2];

				if (blockData.presetId == 1) {
					activeBlockData.passes[4].enabled = false;
				}

				$block.find(".opacity-input").val(parseInt(blockData.opacity));
				$block.find(".opacity-input").trigger("change");

				window.lutify.getActiveBlock().collapsedPreviews = blockData.collapsedPreviews;

				gpu.render();
				lutPreviewer.render();

				this.updatePresetList(preset);
			}

			$block.find(".controls-wrapper .switch > input").trigger("click");
		} finally {
			vm.$store.dispatch('App/setBlockLoading', false);
			$('#blocks-container--outer').removeClass('--overlay');
			$('#project-navigator-container').removeClass('--overlay');
			$('#filmstrip-container .thumbnail-container').removeClass('--overlay');
			vm.$store.dispatch("Loader/showProgressBar", false);
		}
	}
}